import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import ContactSection from '@/pages/home/components/ContactSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import AppSection from '@/pages/home/components/AppSection';
import CardsSection from '@/pages/home/components/CardsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import MediaSection from '@/pages/home/components/MediaSection';
import AboutSection from '@/pages/home/components/AboutSection';
import IndexSection from '@/pages/home/components/IndexSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import RankingSection from '@/pages/home/components/RankingSection';
import CarouselSection from '@/pages/home/components/CarouselSection';

export default function Home() {
  return (
    <>
      <Header />

      <main>
        <HeroSection />
        <ContactSection />
        <FeaturesSection />
        <AppSection />
        <CardsSection />
        <FaqSection />
        <TopicsSection />
        <CommentsSection />
        <MediaSection />
        <AboutSection />
        <IndexSection />
        <UpdatesSection />
        <RankingSection />
        <CarouselSection />
      </main>

      <Footer />
    </>
  );
}